import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@material-ui/core';
import preinformeStyles from './preinformeStyles';

/**
 * Aviso destacado de solo lectura con una línea por advertencia del payload.
 * No renderiza nada cuando `advertencias` está vacío.
 */
const AvisoAdvertencias = ({ advertencias }) => {
    const classes = preinformeStyles();

    if (!advertencias || advertencias.length === 0) {
        return null;
    }

    return (
        <Paper className={classes.avisoBox} role="alert" elevation={0}>
            {advertencias.map((advertencia) => (
                <Typography key={advertencia} className={classes.avisoTexto}>
                    {advertencia}
                </Typography>
            ))}
        </Paper>
    );
};

AvisoAdvertencias.propTypes = {
    advertencias: PropTypes.arrayOf(PropTypes.string),
};

AvisoAdvertencias.defaultProps = {
    advertencias: [],
};

export default AvisoAdvertencias;
